var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 4.44172C11.3333 4.10839 12.2 3.64172 13 4.44172L19 10.4417C19.7132 11.155 20 11.5 20 12V19C20 19.5 19.5 20 19 20H15C14.2 20 14 19.3333 14 19V16C14 15.3333 13.6 14 12 14C10.4 14 10 15.3333 10 16V19C10 19.8 9.33333 20 9 20H5C4.5 20 4 19.5 4 19V12C4 11.5 4.2 11.2417 5 10.4417L11 4.44172Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHome);
export default __webpack_public_path__ + "static/media/ico-home.6dd7dfc246b0758e9a6957bbc6accedf.svg";
export { ForwardRef as ReactComponent };